import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GiftIcon, ShieldCheckIcon, LockIcon, DownloadIcon, StarIcon, ShieldAlertIcon, ClipboardCheckIcon, TrendingDownIcon, TrophyIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function BonusStack() {
  const bonuses = [{
    id: 1,
    icon: StarIcon,
    emoji: '🏆',
    title: 'Las creatinas que sí valen la pena (Lista actualizada 2026)',
    description: 'Las marcas que realmente cumplen estándares de pureza.',
    value: '$26.337'
  }, {
    id: 2,
    icon: ShieldAlertIcon,
    emoji: '🚩',
    title: 'La lista negra de la creatina',
    description: 'Marcas con marketing engañoso que no cumplen estándares de pureza.',
    value: '$23.565'
  }, {
    id: 3,
    icon: ClipboardCheckIcon,
    emoji: '📝',
    title: 'Checklist: Cómo elegir una creatina en 30 segundos',
    description: 'Criterios rápidos para discernir entre creatinas que no están analizadas en este manual.',
    value: '$12.476'
  }, {
    id: 4,
    icon: TrendingDownIcon,
    emoji: '💸',
    title: 'Cuánto dinero estás perdiendo comprando mal',
    description: 'Ejemplos reales de precios inflados y cómo pagar menos por mejor calidad.',
    value: '$26.337'
  }];
  const totalBonusValue = '$88.715';
  const stackItems = [{
    name: 'Manual Prohibido de la Creatina',
    price: '$40.199'
  }, {
    name: 'Bonus #1',
    price: '$26.337'
  }, {
    name: 'Bonus #2',
    price: '$23.565'
  }, {
    name: 'Bonus #3',
    price: '$12.476'
  }, {
    name: 'Bonus #4',
    price: '$26.337'
  }];
  return <section id="bonos" className="w-full bg-[#0B1C2C] py-24 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        {/* 1. SECTION TITLE */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-3">
          <div className="inline-flex items-center gap-2 bg-[#2F6BFF]/20 border border-[#2F6BFF]/50 rounded-full px-6 py-3 mb-8" data-id="element-4">
            <GiftIcon className="w-5 h-5 text-[#2F6BFF]" data-id="element-5" />
            <span className="text-[#7EC8FF] font-bold tracking-wide uppercase text-sm" data-id="element-6">
              Regalos Exclusivos
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#F2F4F8] mb-6 leading-tight" data-id="element-7">
            Además del manual, obtienes{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#2F6BFF] to-[#7EC8FF]" data-id="element-8">
              4 bonos
            </span>{' '}
            completamente GRATIS
          </h2>
        </motion.div>

        {/* 2. COMPACT BONUS ROWS */}
        <div className="space-y-4 mb-8" data-id="element-9">
          {bonuses.map((bonus, index) => {
          const IconComponent = bonus.icon;
          return <motion.div key={bonus.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.08
          }} className="bg-[#132A44] border border-[#2F6BFF]/20 rounded-xl px-5 py-5 sm:px-7 sm:py-6 hover:border-[#2F6BFF]/40 transition-colors" data-id="element-10">
                {/* Desktop layout */}
                <div className="hidden sm:flex items-center gap-5" data-id="element-11">
                  <div className="flex-shrink-0 w-14 h-14 bg-[#FFE600]/10 border border-[#FFE600]/30 rounded-xl flex items-center justify-center" data-id="element-12">
                    <span className="text-3xl" data-id="element-13">{bonus.emoji}</span>
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-14">
                    <h3 className="text-lg font-bold text-[#F2F4F8] leading-snug" data-id="element-15">
                      {bonus.title}
                    </h3>
                    <p className="text-base text-[#F2F4F8]/60 mt-0.5 leading-relaxed" data-id="element-16">
                      {bonus.description}
                    </p>
                  </div>
                  <div className="flex-shrink-0" data-id="element-17">
                    <span className="inline-block bg-[#2F6BFF]/15 border border-[#2F6BFF]/40 text-[#7EC8FF] text-sm font-bold px-4 py-1.5 rounded-full uppercase tracking-wider" data-id="element-18">
                      Incluido
                    </span>
                  </div>
                </div>

                {/* Mobile layout */}
                <div className="flex sm:hidden flex-col gap-3" data-id="element-19">
                  <div className="flex items-center gap-3" data-id="element-20">
                    <div className="flex-shrink-0 w-10 h-10 bg-[#FFE600]/10 border border-[#FFE600]/30 rounded-lg flex items-center justify-center" data-id="element-21">
                      <span className="text-xl" data-id="element-22">{bonus.emoji}</span>
                    </div>
                    <h3 className="text-[15px] font-bold text-[#F2F4F8] leading-snug flex-1" data-id="element-23">
                      {bonus.title}
                    </h3>
                  </div>
                  <p className="text-sm text-[#F2F4F8]/60 leading-relaxed" data-id="element-24">
                    {bonus.description}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>

        {/* BONUS TOTAL SUMMARY BAR */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="bg-[#132A44] border border-[#FFE600]/30 rounded-xl px-6 py-6 sm:px-8 sm:py-6 flex flex-col items-center justify-center gap-3 text-center mb-24" data-id="element-25">
          <div className="flex items-center gap-3" data-id="element-26">
            <span className="text-[#F2F4F8]/70 text-base sm:text-lg" data-id="element-27">
              Los 4 bonos están valorados en:
            </span>
            <span className="text-[#F2F4F8]/50 text-lg sm:text-2xl line-through decoration-red-500/60 decoration-2" data-id="element-28">
              {totalBonusValue}
            </span>
          </div>
          <div className="flex items-center gap-3" data-id="element-29">
            <span className="text-[#FFE600] text-lg sm:text-xl font-medium" data-id="element-30">
              Por el día de hoy →
            </span>
            <span className="bg-[#FFE600]/15 border border-[#FFE600]/40 text-[#FFE600] font-black text-xl sm:text-2xl px-6 py-2 rounded-lg tracking-wide" data-id="element-31">
              GRATIS
            </span>
          </div>
        </motion.div>

        {/* 3. VALUE STACK SUMMARY */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#0E2238] border-2 border-[#2F6BFF]/40 rounded-2xl p-6 sm:p-8 mb-12 shadow-2xl relative overflow-hidden" data-id="element-32">
          <div className="absolute inset-0 bg-gradient-to-br from-[#2F6BFF]/5 to-transparent pointer-events-none" data-id="element-33"></div>

          <h3 className="text-xl sm:text-2xl font-black text-center text-[#F2F4F8] mb-5" data-id="element-34">
            Si compraras todo esto por separado:
          </h3>

          <div className="space-y-2 max-w-3xl mx-auto mb-5" data-id="element-35">
            {stackItems.map((item, index) => <div key={index} className="flex justify-between items-center border-b border-[#F2F4F8]/10 pb-2" data-id="element-36">
                <span className="text-[#F2F4F8]/80 text-base sm:text-lg" data-id="element-37">
                  {item.name}
                </span>
                <span className="text-[#F2F4F8] font-bold text-base sm:text-lg" data-id="element-38">
                  {item.price}
                </span>
              </div>)}
          </div>

          <div className="bg-[#132A44] border border-[#FFE600]/30 rounded-xl p-4 text-center max-w-3xl mx-auto" data-id="element-39">
            <p className="text-[#F2F4F8]/80 text-sm mb-1 uppercase tracking-widest font-semibold" data-id="element-40">
              Valor total del combo
            </p>
            <p className="text-3xl sm:text-4xl font-black text-[#FFE600]" data-id="element-41">
              $128.900
            </p>
          </div>
        </motion.div>

        {/* 4. PRICE DROP MOMENT & 5. PSYCHOLOGICAL LINE & 6. FINAL CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-center" data-id="element-42">
          <div className="mb-10 space-y-2" data-id="element-43">
            <p className="text-2xl sm:text-3xl text-red-400/80 font-bold line-through decoration-red-500/50 decoration-4" data-id="element-44">
              No pagarás $128.900
            </p>
            <p className="text-2xl sm:text-3xl text-red-400/80 font-bold line-through decoration-red-500/50 decoration-4" data-id="element-45">
              Ni siquiera $65.000
            </p>
          </div>

          <div className="mb-12" data-id="element-46">
            <p className="text-xl sm:text-2xl text-[#F2F4F8] mb-6 font-medium" data-id="element-47">
              Hoy puedes acceder a todo el combo por solo:
            </p>
            <a href="https://creatinadesdecero.com/checkouts/cn/hWNAvfp4CaM7X6fdTqgOuFiT/es-ar?_r=AQAByQrvKKRvNL4yOlwASBJc3aRvs1RDUduK9RlYs9H7pb0&preview_theme_id=176488644801" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-to-r from-[#2F6BFF]/20 to-[#7EC8FF]/20 border-2 border-[#2F6BFF] rounded-3xl px-12 py-6 shadow-[0_0_40px_rgba(47,107,255,0.3)] hover:shadow-[0_0_60px_rgba(47,107,255,0.5)] hover:scale-[1.03] transition-all duration-300 cursor-pointer" data-id="element-48">
              <span className="text-6xl sm:text-7xl lg:text-8xl font-black text-[#FFE600] drop-shadow-lg" data-id="element-49">
                $14.990
              </span>
            </a>
          </div>

          <div className="max-w-2xl mx-auto mb-10 bg-[#132A44]/50 border-l-4 border-[#2F6BFF] p-6 rounded-r-xl text-left" data-id="element-50">
            <p className="text-xl text-[#F2F4F8]/90 italic font-medium leading-relaxed" data-id="element-51">
              "Si esta información te ayuda a evitar comprar una sola creatina
              mala, el manual ya se pagó solo."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}